import { isNil } from 'lodash';

const getPercentDifference = (val1, val2, showDecimal = true) => {
    if (isNil(val1)) return NaN
    if (isNil(val2) || val2 === 0) return val1 === 0 ? 0 : 100;
    const percent = ((val1 - val2) / val2) * 100;
    return showDecimal ? Number(percent.toFixed(1)) : Math.round(percent);
}

export default getPercentDifference;
